import React, { useEffect, useRef } from 'react';

import ColorItem from './ColorItem';

const ColorItemContainer = ({
  color,
  ...restProps
}: { color: any } & Record<string, any>) => {
  const imageRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (imageRef.current && color) {
      const svgImage = imageRef.current.children[0] as HTMLElement | undefined;

      if (svgImage) {
        svgImage.style.color = color;
      }
    }
  }, [imageRef, color]);

  return <ColorItem {...restProps} imageRef={imageRef} color={color} />;
};

export default React.memo(ColorItemContainer) as any;
